module.exports = __webpack_public_path__ + "img/1729146480971-IMG_4681.jpeg.b359005f.webp";